export default "__VITE_ASSET__83871152__"